import { CheckCircle2 } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const ORGS = [
    { name: "International Tennis Federation", src: "/logos/itf.png", tile: false },
    { name: "Davis Cup", src: "/logos/davis.svg", tile: true },
    { name: "Billie Jean King Cup", src: "/logos/bjk.svg", tile: true },
    { name: "COSAT", src: "/logos/cosat.png", tile: false },
];

export default function Traction() {
    const { t } = useI18n();
    const tr = t.traction;
    return (
        <section
            id="traction"
            data-testid="traction-section"
            className="relative py-24 md:py-32 border-t border-white/5"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-8 mb-14 reveal">
                    <div className="lg:col-span-7">
                        <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#D4FF00] mb-4">
                            {tr.tag}
                        </div>
                        <h2 className="font-display font-bold uppercase text-4xl md:text-5xl lg:text-6xl tracking-tighter heading-clamp">
                            {tr.headline}{" "}
                            <span className="text-[#D4FF00]">{tr.headlineAccent}</span>
                        </h2>
                    </div>
                </div>

                <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
                    {tr.stats.map(([n, label], i) => (
                        <div
                            key={label}
                            data-testid={`traction-stat-${i}`}
                            className="card-hover rounded-2xl border border-white/10 bg-[#071B12] p-7 reveal"
                            style={{ transitionDelay: `${i * 80}ms` }}
                        >
                            <div className="font-display font-bold tabular text-5xl md:text-6xl tracking-tighter text-[#D4FF00] leading-none lime-text-glow">
                                {n}
                            </div>
                            <div className="mt-3 text-sm text-white/65 leading-snug">
                                {label}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="grid md:grid-cols-2 gap-5 reveal">
                    {tr.milestones.map((m, i) => (
                        <div
                            key={i}
                            data-testid={`milestone-${i}`}
                            className="rounded-2xl border border-white/10 bg-[#071B12] p-6 flex gap-4"
                        >
                            <CheckCircle2
                                size={22}
                                className="text-[#D4FF00] flex-shrink-0 mt-0.5"
                            />
                            <p className="text-[15px] text-white/80 leading-relaxed">{m}</p>
                        </div>
                    ))}
                </div>

                <div className="mt-16 reveal" data-testid="trusted-players-block">
                    <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#D4FF00] mb-5">
                        {tr.trustedTitle}
                    </div>
                    <div className="flex flex-wrap gap-2.5">
                        {tr.trustedItems.map((p, i) => (
                            <span
                                key={p}
                                data-testid={`trusted-item-${i}`}
                                className="px-4 py-2 rounded-full border border-white/12 bg-[#071B12] text-sm font-semibold text-white/85 hover:border-[#D4FF00]/50 hover:text-white transition-colors"
                            >
                                {p}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="mt-10 reveal" data-testid="trusted-orgs-block">
                    <div className="rounded-2xl border border-white/10 bg-[#071B12] p-6 md:p-8">
                        <p className="text-[15px] text-white/65 leading-relaxed max-w-3xl mb-6">
                            {tr.orgsNote}
                        </p>
                        <div className="flex flex-wrap items-center gap-x-10 gap-y-6">
                            {ORGS.map((o) => (
                                <div
                                    key={o.name}
                                    className={
                                        o.tile
                                            ? "bg-white rounded-xl px-4 py-2.5 flex items-center"
                                            : "flex items-center"
                                    }
                                    title={o.name}
                                >
                                    <img
                                        src={o.src}
                                        alt={o.name}
                                        className={
                                            o.name === "COSAT"
                                                ? "h-14 w-14 rounded-lg object-cover"
                                                : "h-10 md:h-12 w-auto object-contain"
                                        }
                                        loading="lazy"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
